import templateUrl from "./user-global-roles-editor.component.html";
export const UserGlobalRolesEditorComponent = {
    templateUrl,
    controllerAs: "vm",
    require: {
        parentForm: "^^?form"
    },
    bindings: {
        employee: "<",
        identity: "<",
        isSelfSignUp: "<"
    },
    controller: class {
        $onInit() {
            if (!this.parentForm) {
                // Note, parentForm is the parent form, whereas employeeForm is the local form.
                window.onbeforeunload = () => {
                    if (this.employeeForm && this.employeeForm.$dirty) {
                        return "There are unsaved changes. Are you sure you want to abandon them?"
                    }
                }
            }
        }
    }
}
